import styled from "styled-components";

export const PageContainer = styled.div``;

export const PageContent = styled.div`
  max-width: 767px;
  margin: 42px auto;

  > h2 {
    font-size: 1.5rem;
    color: #dd6435;
    margin-bottom: 8px;
  }

  > h3 {
    margin: 16px 0;
    font-size: 1.25rem;
  }

  .last-update {
    font-size: 0.9rem;
    color: hsl(0, 0%, 0%);
    margin-bottom: 18px;
  }

  .legal-notice {
    padding: 12px 14px;
    margin-bottom: 20px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.palette.secondary.orange200};
    background-color: ${({ theme }) => theme.palette.secondary.orange50};
    color: ${({ theme }) => theme.palette.greyscale.grey800};
    font-size: 0.9rem;
    line-height: 1.5;
  }

  .placeholder-section {
    padding: 12px 0;
    color: ${({ theme }) => theme.palette.greyscale.grey700};
    font-style: italic;
    line-height: 1.5;
  }

  .agreement {
    margin-top: 16px;
    font-size: 0.9rem;
  }

  @media (max-width: 767px) {
    margin: 0 16px 32px;

    > h2 {
      font-size: 17px;
    }

    > p {
      font-size: 13px;
    }

    .last-update {
      font-size: 0.7rem;
      margin-bottom: 18px;
    }
  }
`;

export const TextBlock = styled.section`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
